export function implementaValorEnTodosLosFormu(elementToHandle) {

    const listElementNewValue = document.getElementsByName(elementToHandle.name);

    for (const element in listElementNewValue) {
        if (listElementNewValue[element].id != null) {
            const inputContainer = document.getElementById(listElementNewValue[element].id);
            inputContainer.value = elementToHandle.value;
        };
    }

}